import { BaseService } from './baseService';

class SmsMessageTemplatesService extends BaseService<
	SmsMessageTemplate,
	'smsMessageTemplateID',
	'smsMessageTemplates'
> {
	constructor() {
		super(
			'smsMessageTemplateID',
			'smsMessageTemplate',
			'smsMessageTemplates',
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SmsMessageTemplatesService();
